import { useIsMutating } from '@tanstack/react-query';
import FormWithProvider from 'components/forms/form/Form';
import FormFieldset from 'components/forms/form/FormFieldset';
import ModalFormCancelButton from 'components/modal/form/ModalFormCancelButton';
import ModalFormSubmitButton from 'components/modal/form/ModalFormSubmitButton';
import { RentalConditions } from 'models/RentalCondition';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import {
  DefinitionRadioOptions,
  EditRentalConditionsFormSchemaType,
  editSchema,
} from './EditRentalConditionsModal.schema';
import { EditModalContainer } from './EditRentalConditionsModal.styles';
import EditRentalConditionsModalFields from './EditRentalConditionsModalFields';

const EditRentalConditionsModal = ({
  rentalConditions,
  onSubmit,
  mutationKey,
}: {
  rentalConditions: RentalConditions;
  onSubmit: (rentalConditions: EditRentalConditionsFormSchemaType) => void;
  mutationKey: string[];
}) => {
  const { t } = useTranslation();

  const isMutating = useIsMutating({
    mutationKey,
  });

  const isLoading = isMutating > 0;

  return (
    <EditModalContainer>
      <FormWithProvider
        horizontal={false}
        schema={editSchema()}
        onSubmit={onSubmit}
        defaultValues={{
          rentalConditions: rentalConditions?.inheritFromAgency
            ? ''
            : rentalConditions.rentalConditions,
          definition: rentalConditions?.inheritFromAgency
            ? DefinitionRadioOptions.AGENCY
            : DefinitionRadioOptions.PROPERTY,
        }}
        noValidate
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {t(
              'pageProperty.feesTaxesAndPolicies.rentalConditions.editModal.title',
            )}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <FormFieldset disabled={isLoading}>
            <EditRentalConditionsModalFields />
          </FormFieldset>
        </Modal.Body>

        <Modal.Footer>
          <ModalFormCancelButton disabled={isLoading} />
          <ModalFormSubmitButton disabled={isLoading} />
        </Modal.Footer>
      </FormWithProvider>
    </EditModalContainer>
  );
};

export default EditRentalConditionsModal;
